(ns kyber.kyber-db.core
  (:require [kyber.kyber-db.activity :as activity]
            [kyber.kyber-db.activity-director-report :as activity-director-report]
            [kyber.kyber-db.activity-resource :as activity-resource]
            [kyber.kyber-db.activity-mindset-readiness-diagnostic :as activity-mindset-readiness-diagnostic]
            [kyber.kyber-db.assessment :as assessment]
            [kyber.kyber-db.content-provider :as content-provider]
            [kyber.kyber-db.content-provider-tag :as content-provider-tag]
            [kyber.kyber-db.content-provider-tag-group :as content-provider-tag-group]
            [kyber.kyber-db.current-user :as current-user]
            [kyber.kyber-db.curriculum :as curriculum]
            [kyber.kyber-db.curriculum-learner :as curriculum-learner]
            [kyber.kyber-db.external-user :as external-user]
            [kyber.kyber-db.hr-manager-report-team-data :as hr-manager-report-team-data]
            [kyber.kyber-db.hr-manager-report-learner-data :as hr-manager-report-learner-data]
            [kyber.kyber-db.report-learner-data :as report-learner-data]
            [kyber.kyber-db.learning-objective :as learning-objective]
            [kyber.kyber-db.moment :as moment]
            [kyber.kyber-db.question :as question]
            [kyber.kyber-db.question-context :as question-context]
            [kyber.kyber-db.questionnaire :as questionnaire]
            [kyber.kyber-db.resource :as resource]))

(def ^:dynamic db-schema
  {:activity activity/model
   :activity-director-report activity-director-report/model
   :activity-resource (assoc resource/model :ident-key activity-resource/->ident-key)
   :activity-mindset-readiness-diagnostic activity-mindset-readiness-diagnostic/model
   :assessment assessment/model
   :content-provider content-provider/model
   :content-provider.tag content-provider-tag/model
   :content-provider.tag-group content-provider-tag-group/model
   :current-user current-user/model
   :curriculum curriculum/model
   :curriculum-learner curriculum-learner/model
   :external-user external-user/model
   :hr-manager-report-team-data hr-manager-report-team-data/model
   :hr-manager-report-learner-data hr-manager-report-learner-data/model
   :report-learner-data report-learner-data/model
   :learning-objective learning-objective/model
   :moment moment/model
   :question question/model
   :question-context question-context/model
   :questionnaire questionnaire/model
   :resource resource/model})
